// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Ywn-lt-cWK8j8GTitxll_"};